import { ADDRESSES_LOADED, LOAD_ADDRESSES, RESET_ADDRESSES, SYNC_FAILED } from './actionTypes';

export const initialState = {
  error: null,
  loaded: false,
  addresses: [],
  loading: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_ADDRESSES:
      return { ...state, error: null, loading: true, addresses: [] };
    case ADDRESSES_LOADED:
      return {
        ...state,
        error: null,
        addresses: action.payload,
        loading: false,
        loaded: true,
      };

    case RESET_ADDRESSES:
      return initialState;
    case SYNC_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
